import { filterSingleByDuration } from './simple';
import { filterCustomByDuration } from './custom';

import {
  getCustomClusterMinMaxDuration,
  getClusterMinMaxDuration,
} from './available';

export const durationFilter = (
  searchResults,
  maxDuration,
  isCustom,
  minInitial
) =>
  isCustom
    ? filterCustomByDuration(searchResults, maxDuration)
    : filterSingleByDuration(searchResults, maxDuration, minInitial);

export const getDurationBySearchType = isCustomSearch =>
  isCustomSearch ? getCustomClusterMinMaxDuration : getClusterMinMaxDuration;
